import React from 'react'

const StoreContext = React.createContext()
StoreContext.displayName = 'StoreContext'

export default StoreContext
